module.exports = __webpack_public_path__ + "assets/shared2.22cc0896.svg";